function initHeroSlider(root) {
  const slides = Array.from(root.querySelectorAll(".hero-slider__slide"));
  const bgs = Array.from(root.querySelectorAll(".hero-slider__slide-bg"));
  const cards = Array.from(root.querySelectorAll(".hero-slider__card"));
  const tracks = Array.from(root.querySelectorAll(".hero-slider__progress-track"));
  const autoplay = root.dataset.autoplay !== "false";
  const duration = parseInt(root.dataset.autoplaySpeed, 10) || 6000;

  let current = 0;
  let timer = null;

  function animateProgress(activeIndex) {
    tracks.forEach((track, index) => {
      const fill = track.querySelector(".hero-slider__progress-fill");
      if (!fill) return;

      fill.style.transition = "none";
      fill.style.width = "0%";

      if (index === activeIndex) {
        void fill.offsetWidth;
        fill.style.transition = "width " + duration + "ms linear";
        fill.style.width = "100%";
      }
    });
  }

  function goTo(index) {
    if (index === current) return;

    slides[current] && slides[current].classList.remove("is-active");
    bgs[current] && bgs[current].classList.remove("is-active");
    if (cards[current]) {
      cards[current].classList.remove("is-active");
      cards[current].setAttribute("aria-selected", "false");
    }

    current = index;

    slides[current] && slides[current].classList.add("is-active");
    bgs[current] && bgs[current].classList.add("is-active");
    if (cards[current]) {
      cards[current].classList.add("is-active");
      cards[current].setAttribute("aria-selected", "true");
    }

    animateProgress(current);
  }

  function play() {
    clearTimeout(timer);
    if (!autoplay || slides.length < 2) return;
    timer = setTimeout(function () {
      goTo((current + 1) % slides.length);
      play();
    }, duration);
  }

  cards.forEach((card) => {
    card.addEventListener("click", () => {
      const index = parseInt(card.dataset.index, 10);
      goTo(index);
      play();
    });
  });

  animateProgress(current);
  play();
}

document.querySelectorAll("[data-hero-slider]").forEach(initHeroSlider);

document.addEventListener("shopify:section:load", (event) => {
  const root = event.target.querySelector("[data-hero-slider]");
  if (root) initHeroSlider(root);
});
